import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { canBrowserHistoryBack } from '../../utils/history-back.util';
import { PageBackIconsModule } from './page-back-icons.module';

@Component({
  selector: 'app-page-back-btn',
  standalone: true,
  imports: [PageBackIconsModule],
  template: `
    @if (visible()) {
      <button
        type="button"
        class="btn secondary page-head-back dms-page-back-btn"
        aria-label="Go back"
        (click)="onBack()"
      >
        <lucide-icon name="arrow-left" [size]="18" [strokeWidth]="2" />
      </button>
    }
  `,
})
export class PageBackButtonComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  /** Explicit route when history back is unavailable. */
  @Input() link?: string | null;
  @Input() show = true;
  /** Prefer browser history (return to the screen the user came from). */
  @Input() preferHistory = true;
  @Output() readonly back = new EventEmitter<void>();

  visible(): boolean {
    if (!this.show) {
      return false;
    }
    if (this.back.observed) {
      return true;
    }
    if (this.link) {
      return true;
    }
    return !!this.route.snapshot.data['mobileBack'];
  }

  onBack(): void {
    if (this.back.observed) {
      this.back.emit();
      return;
    }
    if (this.preferHistory && canBrowserHistoryBack()) {
      this.location.back();
      return;
    }
    const target = this.link ?? this.route.snapshot.data['mobileBack'] ?? '/dms';
    if (typeof target === 'string' && target.length > 0) {
      void this.router.navigateByUrl(target);
    }
  }
}
